import React from 'react'
import PropTypes from 'prop-types'
import { StyledDetailsWrapper } from './styles'
import { GameScreenshotModal } from '../gameScreenshotModal'
import { Title } from '../../atoms/text'

const DescriptionsList = (props) => {
  const { content, initiallyOpen, fallbackTitle } = props
  const filteredContent = (content ?? []).filter((group) => group.description)

  let fallbackIndex = 0

  const getTitle = (group) => {
    if (group.title) return group.title
    if (fallbackIndex++ > 0) return `${fallbackTitle} ${fallbackIndex}.`
    return `${fallbackTitle}`
  }

  return (
    <div>
      <GameScreenshotModal title={fallbackTitle} />
      <StyledDetailsWrapper>
        {filteredContent.map((group, i) => (
          <details key={`description-${i}`} open={initiallyOpen}>
            <summary>
              <Title level={2}>{getTitle(group)}</Title>
            </summary>
            <div dangerouslySetInnerHTML={{ __html: group.description }} />
          </details>
        ))}
      </StyledDetailsWrapper>
    </div>
  )
}

DescriptionsList.defaultProps = {
  initiallyOpen: true,
  content: [],
}

DescriptionsList.propTypes = {
  initiallyOpen: PropTypes.bool,
  fallbackTitle: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
}

export { DescriptionsList }
